import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(eliminarTextos),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarHerramientaGrupoTexto);

import { put, call, select } from 'redux-saga/effects';
import { seleccionarHerramienta } from '../../actions';
import { eliminarTextos as eliminarTextosAction, modoCrearTexto } from '../../texto-usuario/actions';
import { getPantalla, getPantallaProps, barraHerramientasSelectors } from '../../selectors';
import { PANTALLA_VENTANA_ID, PANTALLA_LIBRO_ID } from '../../constantes';
import { getNumPaginaIzquierda } from '../../selectors/config-libro';
import * as Util from '../../util';
import { PUNTERO_ID, GRUPO_PIZARRA, TEXTO_ID, NOTA_ID, VINCULO_ID, ELIMINAR_NOTAS_ID } from '../../herramientas/constantes';
import * as constantesTextoUsuario from '../../texto-usuario/constantes';
export function eliminarTextos() {
  var pantallaActualId, pantallaActualProps, libroId, numPagina, numZona, numPaginaIzquierda;
  return _regeneratorRuntime.wrap(function eliminarTextos$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(getPantalla);

        case 2:
          pantallaActualId = _context.sent;
          _context.next = 5;
          return select(getPantallaProps, pantallaActualId);

        case 5:
          pantallaActualProps = _context.sent;
          libroId = pantallaActualProps.libroId, numPagina = pantallaActualProps.numPagina, numZona = pantallaActualProps.numZona;
          _context.t0 = pantallaActualId;
          _context.next = _context.t0 === PANTALLA_VENTANA_ID ? 10 : _context.t0 === PANTALLA_LIBRO_ID ? 13 : 21;
          break;

        case 10:
          _context.next = 12;
          return put(eliminarTextosAction(libroId, numPagina, numZona));

        case 12:
          return _context.abrupt('break', 21);

        case 13:
          _context.next = 15;
          return select(getNumPaginaIzquierda, libroId, numPagina);

        case 15:
          numPaginaIzquierda = _context.sent;
          _context.next = 18;
          return put(eliminarTextosAction(libroId, numPaginaIzquierda));

        case 18:
          _context.next = 20;
          return put(eliminarTextosAction(libroId, numPaginaIzquierda + 1));

        case 20:
          return _context.abrupt('break', 21);

        case 21:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}
export function seleccionarHerramientaGrupoTexto(action) {
  var pantallaId, boton, mensaje;
  return _regeneratorRuntime.wrap(function seleccionarHerramientaGrupoTexto$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.t0 = action.herramientaId;
          _context2.next = _context2.t0 === TEXTO_ID ? 3 : _context2.t0 === NOTA_ID ? 6 : _context2.t0 === VINCULO_ID ? 9 : _context2.t0 === ELIMINAR_NOTAS_ID ? 12 : 25;
          break;

        case 3:
          _context2.next = 5;
          return put(modoCrearTexto(constantesTextoUsuario.TIPO_TEXTO));

        case 5:
          return _context2.abrupt('break', 25);

        case 6:
          _context2.next = 8;
          return put(modoCrearTexto(constantesTextoUsuario.TIPO_NOTA));

        case 8:
          return _context2.abrupt('break', 25);

        case 9:
          _context2.next = 11;
          return put(modoCrearTexto(constantesTextoUsuario.TIPO_VINCULO));

        case 11:
          return _context2.abrupt('break', 25);

        case 12:
          _context2.next = 14;
          return select(getPantalla);

        case 14:
          pantallaId = _context2.sent;
          _context2.next = 17;
          return select(barraHerramientasSelectors.getBoton, action.herramientaId);

        case 17:
          boton = _context2.sent;
          mensaje = pantallaId === PANTALLA_VENTANA_ID ? boton.mensajeVentana || boton.mensaje : boton.mensaje;

          if (!Util.confirm(mensaje)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 22;
          return call(eliminarTextos);

        case 22:
          _context2.next = 24;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 24:
          return _context2.abrupt('break', 25);

        case 25:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}